import { useEffect, useState } from 'react';
import { TextService } from '../../../Services/TextService';
import { useAuth } from '../../../Contexts/AuthContext';
import { MemberService } from '../../../Services/MemberService';
import LeftMenu from '../../../PagesAdmin/Users/LeftMenu';
import Paragraph from 'antd/lib/typography/Paragraph';
import { WebApiMemberDtoMemberListResultDto, WebApiMemberFieldsDtoMemberUploadFieldDto } from '../../../Repository/eventbookyapi';
import LayoutLeftMenu from '../../Layout/LayoutLeftMenu';
import { BookyTitleWithIcon } from '../../Forms/TitleWithIcon';
import { Button, Col, Dropdown, message } from 'antd';
import { DownloadOutlined, FilePdfOutlined, UploadOutlined } from '@ant-design/icons';
import { BookyButton } from '../../Buttons/BookyButton';
import { SubscriptionLevel } from '../../../Types/SubscriptionLevel';
import { MemberFieldService } from '../../../Services/MemberFieldService';
import { UploadMemberPreviewData } from './UploadMemberPreviewTable';
import UploadMemberButton from './UploadMemberButton';

const UploadMembers = () => {
    const [memberResult, setMemberResult] = useState({} as WebApiMemberDtoMemberListResultDto);
    const { user } = useAuth();
    const GetText = TextService.GetText;
    const [showFullPageSpinner, setShowFullPageSpinner] = useState(false as boolean);
    const [addressLabelLoading, setAddressLabelLoading] = useState(false);
    const [templateLoading, setTemplateLoading] = useState(false);
    const [uploadTemplateFields, setUploadTemplateFields] = useState([] as WebApiMemberFieldsDtoMemberUploadFieldDto[]);

    useEffect(() => {
        MemberFieldService.GetMemberUploadFields().then(uploadFields => {
            setUploadTemplateFields(uploadFields);
        });
    }, []);


    const downloadExcel = async () => {
        if (user?.subscriptionLevel === SubscriptionLevel.Free) {
            message.warning(GetText("MyEventDetails_SorryOnlyPremium"));
            return;
        };
        setShowFullPageSpinner(true);
        const data = await MemberService.GetMembersAsFile();
        const url = window.URL.createObjectURL(await data.raw.blob());
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `Members_${Date.now()}.xlsx`);
        document.body.appendChild(link);
        link.click();
        setShowFullPageSpinner(false);
    }

    const downloadTemplateMembers = async () => {
        if (user?.subscriptionLevel === SubscriptionLevel.Free) {
            message.warning(GetText("MyEventDetails_SorryOnlyPremium"));
            return;
        };
        setTemplateLoading(true);
        try {
            const data = await MemberFieldService.CreateMemberUploadTemplate();
            const url = window.URL.createObjectURL(await data.raw.blob());
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `Members_Template_${Date.now()}.xlsx`);
            document.body.appendChild(link);
            link.click();
        } catch {
            message.error(GetText('Common_Error'));
        }
        setTemplateLoading(false);
    }

    useEffect(() => {
        loadMembers();
    }, []);

    const downloadAddressLabels = async (onlyWithoutEmail: boolean) => {
        if (user?.subscriptionLevel === SubscriptionLevel.Free) {
            message.warning(GetText("MyEventDetails_SorryOnlyPremium"));
            return;
        }
        setAddressLabelLoading(true);
        try {
            const data = await MemberService.GetAddressLabelsPdf(onlyWithoutEmail);
            const url = window.URL.createObjectURL(await data.raw.blob());
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `AdressEtiketter_${Date.now()}.pdf`);
            document.body.appendChild(link);
            link.click();
        } catch {
            message.error(GetText('AddressLabels_Error'));
        }
        setAddressLabelLoading(false);
    };

    const loadMembers = () => {
        MemberService.GetAllMembers().then(result => {
            setMemberResult(result);
        });
    }

    return <LayoutLeftMenu fullpageMain={true} menu={<LeftMenu selected={"users"}></LeftMenu>}>

        <Col span={16}>
            <Col className='bookyBox' style={{ marginLeft: "20px", marginTop: "20px" }}>
                <BookyTitleWithIcon text={GetText("Users_UsersFromFileTitle")}><UploadOutlined /></BookyTitleWithIcon>

                <Paragraph>{GetText("UploadMembers_UploadCsvDescription1")}<br />
                    {GetText("UploadMembers_UploadCsvDescription2")}
                </Paragraph>

                <Button
                    icon={<DownloadOutlined />}
                    loading={templateLoading}
                    onClick={downloadTemplateMembers}
                >
                    {GetText("MemberList_Download_Template")}
                </Button>
                <br /><br />
                {memberResult.members && (
                    <UploadMemberButton members={memberResult.members!} totalMemberCount={memberResult.members!.length} user={user!} groups={memberResult.groups!} uploadTemplateFields={uploadTemplateFields} />
                )}

            </Col>
            <Col className='bookyBox' style={{ marginLeft: "20px", marginTop: "20px" }}>
                <BookyTitleWithIcon text={"Exportera medlemmar till fil"}><DownloadOutlined /></BookyTitleWithIcon>
                <Paragraph>Här exporterar du hela din medlemslista inklusive betalningar som registrerats till en Excel fil.</Paragraph>
                <BookyButton type="primary" style={{ width: "250px" }} onClick={downloadExcel} icon={<DownloadOutlined />} text={GetText("MemberList_Download")} />
            </Col>
            <Col className='bookyBox' style={{ marginLeft: "20px", marginTop: "20px" }}>
                <BookyTitleWithIcon text={GetText('AddressLabels_Title')}><FilePdfOutlined /></BookyTitleWithIcon>
                <Paragraph>{GetText('AddressLabels_Description')}</Paragraph>
                <Dropdown
                    trigger={['click']}
                    menu={{
                        items: [
                            { key: 'all', label: GetText('AddressLabels_AllMembers'), onClick: () => downloadAddressLabels(false) },
                            { key: 'noemail', label: GetText('AddressLabels_OnlyWithoutEmail'), onClick: () => downloadAddressLabels(true) },
                        ]
                    }}
                >
                    <Button type="primary" style={{ width: "250px" }} icon={<FilePdfOutlined />} loading={addressLabelLoading}>
                        {GetText('AddressLabels_DownloadButton')} ▾
                    </Button>
                </Dropdown>
            </Col>
        </Col>
    </LayoutLeftMenu>
};

export default UploadMembers;